module.exports = __webpack_public_path__ + "static/img/SAM-LALOR.681f5ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SAM-LALOR.jpg
// module id = aqwy
// module chunks = 0